import React from "react";
import "./work-order-pdf.scss";

const WorkOrderPdf = ({ data }) => {
  console.log("WorkOrderPdf data:", data);
  return (
    <div className="work-order-pdf">
      <div>
        <p className="company-name" style={{ margin: "0px" }}>
          Simpson & Co Ltd
        </p>
        <p className="company-name" style={{ marginTop: "5px" }}>
          Service Department
        </p>
      </div>
      <div className="title">FIELD WARRANTY ENGINE - INWARD / WORK ORDER</div>
      <table>
        <tbody>
          <tr>
            <td className="label">PLANT</td>
            <td>{data.plant || "N/A"}</td>
            <td className="label">REF / NO</td>
            <td>{data.fieldWarrantyReferenceNumber || "N/A"}</td>
          </tr>
          <tr>
            <td className="label">DATE</td>
            <td>{new Date().toLocaleDateString() || "N/A"}</td>
            <td className="label">OEM</td>
            <td>{data.oem || "N/A"}</td>
          </tr>
          <tr>
            <td className="label">ENGINE NO</td>
            <td>{data.engineNo || "N/A"}</td>
            <td className="label">QUALITY</td>
            <td> </td>
          </tr>
          <tr>
            <td className="label">INVOICE NO</td>
            <td>{data.invoiceNumber || "N/A"}</td>
            <td className="label">HRS COVERED</td>
            <td>{data.hmr || "N/A"}</td>
          </tr>
          <tr>
            <td className="label">INSPECTED BY</td>
            <td>{data.inspectedBy || "N/A"}</td>
            <td className="label">PLACE</td>
            <td>{data.engineReceivedLocation || "N/A"}</td>
          </tr>
        </tbody>
      </table>

      <div className="section">
        <div className="section-title">COMPLAINT:</div>
        <div className="section-content">
          {data.customerComplaintCode?.description || "N/A"}
        </div>
      </div>

      <div className="section">
        <div className="section-title">SE'S FINDINGS:</div>
        <div className="section-content">{data.seFindings || "N/A"}</div>
      </div>

      <div className="section">
        <div className="section-title">MISSING PARTS:</div>
        <div className="section-content">{data.missingItems || "N/A"}</div>
      </div>

      <div className="section">
        <div className="section-title">DAMAGED PARTS:</div>
        <div className="section-content">{data.damagedItem || "N/A"}</div>
      </div>

      <div className="section">
        <div className="section-title">JOINT INVESTIGATION:</div>
        <div className="section-content">{data.jointInspection || "N/A"}</div>
      </div>

      <div className="section">
        <div className="section-title">ENCLOSURE:</div>
        <div className="section-content">{data.enclosure || "N/A"}</div>
      </div>

      <table className="footer-table">
        <tbody>
          <tr>
            <td className="label">PREPARED BY</td>
            <td style={{ width: "300px" }}> {""}</td>
            <td className="label">AUTHORIZED BY</td>
            <td style={{ width: "300px" }}> {""} </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default WorkOrderPdf;
